import styled from 'styled-components';

export const TabsWrapper = styled.div`
    width: 100%;
`;

export const TabsContainer = styled.div`
    display: inline-flex;
    background: #e9ecef;
    border-radius: 12px;
    padding: 4px;
    gap: 4px;
`;

export const TabButton = styled.button<{ active: boolean }>`
    border: none;
    background: ${({ active }) => (active ? '#ffffff' : 'transparent')};
    padding: 10px 24px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 10px;
    cursor: pointer;
    color: ${({ active }) => (active ? '#111827' : '#6b7280')};
    box-shadow: ${({ active }) =>
        active ? '0 1px 3px rgba(0,0,0,0.08)' : 'none'};
    transition: all 0.2s ease;

    &:hover {
        color: #111827;
    }
`;

export const TabContent = styled.div`
    /* margin: 16px; */
    margin: 16px 8px;
`;
